export class LanguageHelper {
    private static readonly _supportedLanguages = new Set(['sv', 'en']);

    public static resolveCurrentLanguage(pathname: string, cookieString: string): string {
        const languageFromPath = this.resolveLanguageFromPath(pathname);
        if (languageFromPath) {
            return languageFromPath;
        }

        const languageFromCookie = this.resolveLanguageFromCookie(cookieString);
        if (languageFromCookie) {
            return languageFromCookie;
        }

        return 'sv';
    }

    public static resolveLanguageFromCookie(cookieString: string): string | null {
        const cookie = cookieString
            .split(';')
            .map(c => c.trim())
            .find(c => c.startsWith('SelectedLanguage='));

        if (!cookie) {
            return null;
        }

        const selected = cookie.split('=')[1]?.trim()?.toLowerCase();
        return selected && this._supportedLanguages.has(selected) ? selected : null;
    }

    public static resolveLanguageFromPath(pathname: string): string | null {
        const pathMatch = pathname.match(/^\/([a-z]{2})(?:\/|$)/i);
        if (!pathMatch) {
            return null;
        }

        const selected = pathMatch[1].toLowerCase();
        return this._supportedLanguages.has(selected) ? selected : null;
    }
}
